import { Component, ComponentFactoryResolver, Injector, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudEditComponent, CrudEditorParentService, CrudEditorSelfService, FormStorage, USER_TYPE, UserStorage } from '@scisys-uim/uim-common';
import { AssetsUserDetails } from 'assets-model';
import { AssetsUserDetailsItemComponent } from './assets-user-details-item.component';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';


@Component({
  selector: 'app-assets-user-details-editor',
  templateUrl: '../../../../../../../node_modules/@scisys-uim/uim-common/src/lib/crud-components/crud-edit.component.html',
  styleUrls: ['../../../../../../../node_modules/@scisys-uim/uim-common/src/lib/crud-components/crud-edit.component.css'],
  providers: [CrudEditorParentService],
  viewProviders: [CrudEditorSelfService]
})
export class AssetsUserDetailsEditorComponent extends CrudEditComponent<AssetsUserDetails, string> implements OnInit {

  constructor(
    route: ActivatedRoute,
    router: Router,
    userStorage: UserStorage,
    dialog: MatDialog,
    snackbar: MatSnackBar,
    componentFactoryResolver: ComponentFactoryResolver,
    injector: Injector,
    private formStorage: FormStorage) {
    super(route, router, userStorage, dialog, snackbar, componentFactoryResolver, injector);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  itemSet() {
    super.itemSet();
    //this.actions = [];
  }

  ackRoute() {
    if (this.createMode || this.item?.user == null) {
      return USER_TYPE.searchRouteBase;
    }
    return [...(this.readOnly ? USER_TYPE.viewRouteBase : USER_TYPE.editRouteBase), this.item.user]
  }

  isExcludedByExistingUserDetailsType(): boolean {
    const itemComponent: AssetsUserDetailsItemComponent = <AssetsUserDetailsItemComponent>this.itemComponent;
    return itemComponent?.isExcludedByExistingUserDetailsType();
  }

  protected doRetrieveItem(key: string): Observable<AssetsUserDetails> {
    var result = super.doRetrieveItem(key)
    if (key != null) {
      result = result.pipe(map((value, index) => {
        if (value == null) {
          value = new AssetsUserDetails({
            user: key
          });
          this.itemComponent.createMode = true;
        }
        return value;
      }));
    }
    return result;
  }

  isCreateEnabled(): boolean {
    return super.isCreateEnabled() && !this.isExcludedByExistingUserDetailsType();
  }

}






